import type { JSX } from 'react';
import classNames from 'classnames';

import { Typography, Icon, ConditionView, IconName } from '..';

import './ContentField.scss';

interface Props {
  className?: string;
  icon?: IconName;
  content?: string | JSX.Element;
}

export const ContentField: React.FC<Props> = ({ className, icon, content = '' }) => {
  return (
    <div className={classNames('content-field', className)}>
      <div className="content-field__icon">
        {icon && <Icon name={icon} width={160} height={160} color="middle-grey" />}
      </div>
      <div className="content-field__content">
        <ConditionView if={typeof content === 'string'} else={content}>
          <Typography variant="TEXT16" textCenter color="graphite">
            {content}
          </Typography>
        </ConditionView>
      </div>
    </div>
  );
};
